import { FormattedMessage } from "react-intl";
import { useApi } from "../../../hooks";
import Loader from "../../Loader";

type Props = {
  productVariantId: number;
};

export default function ProductCodeDetailsTable({ productVariantId }: Props) {
  const api = useApi();
  const { data, isLoading } = api.get.useQuery(
    `/product_variants/${productVariantId}/configurations`,
    { include_total_count: false },
    { staleTime: Infinity },
  );
  // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
  const filteredConfigurations = data?.configurations?.filter(
    (c: $TSFixMe) => c.options?.length > 0,
  );

  if (isLoading) return <Loader loading />;
  if (filteredConfigurations?.length === 0)
    return <FormattedMessage id="product_code_details.no_details" />;

  return (
    <div>
      {filteredConfigurations?.map((c: $TSFixMe) =>
        c.options.map((o: $TSFixMe) => (
          <div className="product-code-details-item" key={o.id}>
            <div className="product-code-details-item-title">
              {o.option_key}
            </div>
            <div className="product-code-details-item-content">
              <div className="product-option-item-wrapper">
                <div className="product-option-item-title">{c.description}</div>
                <div className="product-option-item-description">
                  {o.description}
                </div>
              </div>
            </div>
          </div>
        )),
      )}
    </div>
  );
}
